export default __webpack_public_path__ + "static/11-f46dcd755907d9e8c15f3c6f4dc621ef.png";